import { RECEIVE_STATS } from "../actions";
const DEFAULT_STATE = {
  stats: { total_transactions: 0, AUD_BSV: 0 },
};

const settingsReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case RECEIVE_STATS:
      return {
        ...state,
        stats: action.stats,
      };

    default:
      return state;
  }
};

export default settingsReducer;
